import { IconButton, InputAdornment, SxProps, TextField, Theme, Tooltip } from "@mui/material";
import { CloseRounded, SearchOutlined } from "@mui/icons-material";

// ----------------------------------------------------------------------

interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  sx?: SxProps<Theme>;
}

/** Campo de busca com lupa (foco dourado vem do override global de Input) */
export default function SearchField({ value, onChange, placeholder = "Buscar...", sx }: SearchFieldProps) {
  return (
    <TextField
      fullWidth
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={placeholder}
      inputProps={{ "aria-label": placeholder }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchOutlined sx={{ fontSize: 18, color: "text.disabled" }} />
          </InputAdornment>
        ),
        endAdornment: value ? (
          <InputAdornment position="end">
            <Tooltip title="Limpar busca" placement="top">
              <IconButton size="small" aria-label="Limpar busca" onClick={() => onChange("")} edge="end">
                <CloseRounded sx={{ fontSize: 18, color: "text.disabled" }} />
              </IconButton>
            </Tooltip>
          </InputAdornment>
        ) : undefined,
      }}
      sx={sx}
    />
  );
}
